import createComponentPreset from "../../../../../fabrics/createComponentPreset";
import { createTestIdForHeaderClose } from "../../../HeaderClose/utils/createTestId";
import CoreHeaderRightAddon from "../../../general/CoreHeader/components/RightAddon/CoreHeaderRightAddon";
import { createDisplayNameForHeader } from "../../utils/createDisplayName";

import type { CoreHeaderRightAddonProps } from "../../../general/CoreHeader/components/RightAddon/CoreHeaderRightAddon";

const displayName = createDisplayNameForHeader("RightAddon");
const testId = createTestIdForHeaderClose("right-addon");

const HeaderRightAddon = createComponentPreset<CoreHeaderRightAddonProps>(
    displayName,
    CoreHeaderRightAddon,
    {
        "data-tsid": testId,
    },
);
export default HeaderRightAddon;
